module.exports = __webpack_public_path__ + "static/media/monthlyPurchaseIcon.af41844a.svg";